<script setup lang="ts">
import { motion } from 'motion-v'

const props = defineProps<{
  isFormExpanded: boolean
}>()

const { t } = useI18n()
</script>

<template>
  <motion.aside
    class="grid grid-cols-1 gap-y-8"
    :initial="{
      opacity: 0,
      x: '-50%',
      skewX: 10,
      filter: 'blur(2px)'
    }"
    :animate="{
      opacity: 1,
      x: 0,
      skewX: 0,
      filter: 'blur(0px)',
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }"
  >
    <header class="text-balance text-xl font-medium lg:text-4xl">
      <h1>
        {{ t('contact_us/existing_customer.introduction.title') }}
      </h1>

      <h2 class="text-neutral-600">
        {{ t('contact_us/existing_customer.introduction.subtitle') }}
      </h2>
    </header>

    <motion.div
      v-show="props.isFormExpanded"
      class="grid place-items-center gap-y-5 rounded-xl bg-neutral-200/40 p-8 lg:place-items-start"
      layout-id="customer-login"
    >
      <UiIcon
        name="headset-mic-outline"
        class="text-4xl text-orange-500"
      />

      <header>
        <h4 class="text-xl font-semibold leading-loose">
          {{ t('contact_us/existing_customer.cards.support.title') }}
        </h4>

        <p>
          {{ t('contact_us/existing_customer.cards.support.description') }}
        </p>
      </header>

      <UiButton as-child>
        <RouterLink
          class="group mx-auto w-full max-w-xs lg:mx-0 lg:max-w-max"
          :to="{ name: '/login' }"
        >
          {{ t('contact_us/existing_customer.cards.support.action') }}

          <UiIcon
            name="arrow-forward-rounded"
            class="transition-transform duration-200 group-hover:translate-x-1"
          />
        </RouterLink>
      </UiButton>
    </motion.div>
  </motion.aside>
</template>
